// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ab3fac86","796":"aacf7623","966":"796cacf8"}[chunkId] + ".chunk.js";
};